import React from 'react';

const Logo = () => {
  return (
    <div className="flex items-center gap-2">
      <img 
        src="https://i.postimg.cc/N9n5MdqK/LC.png" 
        alt="LC Cardinals Logo" 
        className="h-10 w-auto"
        loading="eager"
      />
      <div className="flex flex-col items-start">
        <span className="text-white text-xs font-semibold leading-tight">Lincoln County</span>
        <span className="text-white text-sm font-bold leading-tight">Cardinals</span>
      </div>
    </div>
  );
};

export default Logo;